import { FieldFilterCrop, FieldViewModel, getDistinctValues, groupBy, OmniaConfig, str, utils } from "../omnia"
import { FieldFilterService } from "../services/filter"
import { IFieldsService } from "../types"

/// <reference path="../services/filter.ts" />

export class FieldFilterCtrl {

    static create() {
        return omnia.defineDirective(FieldFilterCtrl, "app/fields/filter/filter.html");
    }


    public fieldNames: string[]

    filter: FieldFilterService

    private crops: FieldFilterCrop[]
    private _crop: FieldFilterCrop

    public cropDescriptions: string[]

    static $inject = ["$scope", "OmniaFieldsService", "omniaConfig"]

    constructor(
        private readonly $scope: ng.IScope,
        private readonly svc: IFieldsService,
        private readonly config: OmniaConfig) {

        this.$scope = $scope;

        const filter = this.svc.filter

        this.filter = new FieldFilterService(filter)

        this.setupCrops()

        const fieldNames = getFieldProp(f => f.fieldName)
        const fieldGroups = getFieldProp(f => f.fieldGroup)

        this.fieldNames = getDistinctValues(fieldNames.concat(fieldGroups), v => v).sort((a, b) => a.localeCompare(b))

        this.cropDescriptions = getDistinctValues(svc.cropping.map(c => c.cropDescription).filter(d => d), d => d).sort((a, b) => a.localeCompare(b))

        function getFieldProp(prop: (f: FieldViewModel) => string) {
            return svc.fields.map(f => prop(f)).filter(n => !!n)
        }

    }

    setupCrops() {

        const cropping = this.svc.cropping.filter(c => c.currentYear)

        this.crops = getHoldingCrops(cropping)
        this._crop = null

        const filter = this.filter

        const { crop } = filter

        if (crop) {
            this.crop = this.crops.find(c => compareCropFilters(c, crop))
        }

    }

    hasActiveFilter() {
        const flt = this.svc.filter
        return flt && (!flt.isEmpty())
    }

    apply() {
        this.svc.filter = this.filter
        this.cancel()
    }

    clear() {
        this.svc.filter = null;
        this.cancel();
    }

    cancel() {
        const scope = this.$scope.$parent["popupContext"]
        scope.open = false
    }

    queryCrops(query: string) {
        if (!query) return []
        const re = new RegExp(utils.regexp.escape(query), "i")
        return this.crops.filter(c => re.test(c.fullName)).slice(0, 20)
    }

    get crop() {
        return this._crop
    }

    set crop(value) {
        this._crop = value
        this.filter.crop = value
    }

}


function getHoldingCrops(cropping: FieldViewModel[]) {

    const crops = groupBy(cropping, c => c.crop, c => c.CropId)
        .map(g => g.key)
        .filter(c => c && c.CropId && c.Name)

    crops.push(<any>{
        CropId: 0,
        Name: str.Uncropped,
        Varieties: []
    })

    const varieties = groupBy(cropping.map(c => c.variety).filter(v => v?.Crop !== undefined), v => v, v => v.CropVarietyId)
        .map(g => g.key)

    const varietyNames = cropping
        .filter(c => !c.varietyId)
        .map(c => ({
            crop: c.crop,
            name: c.getVarietyName(),
        }))
        .filter(v => v.crop && v.name)
        .map(v => ({
            ...v,
            key: `${v.crop.CropId}:${v.name}`
        }))
        .unique(v => v.key)
        .map(v => ({
            cropId: v.crop.CropId,
            isVariety: true,
            varietyId: undefined,
            name: v.name,
            fullName: `${v.crop.Name} - ${v.name}`
        }))

    const results: FieldFilterCrop[] = crops
        .map(c => ({
            cropId: c.CropId,
            varietyId: undefined,
            isVariety: false,
            name: c.Name,
            fullName: c.Name
        }))
        .concat(varieties.map(v => ({
            cropId: v.CropId,
            isVariety: true,
            varietyId: v.CropVarietyId,
            name: v.Name,
            fullName: `${v.Crop.Name} - ${v.Name}`,
        })))
        .concat(varietyNames)
        .sort((a, b) => (a.cropId - b.cropId) || (a.isVariety ? 1 : 0) - (b.isVariety ? 1 : 0) || a.name.localeCompare(b.name))

    return results

}


function compareCropFilters(a: FieldFilterCrop, b: FieldFilterCrop) {

    if (a.cropId !== b.cropId) {
        return false
    }

    if (a.isVariety !== b.isVariety) {
        return false
    }

    if (a.isVariety) {
        return ((a.varietyId ?? 0) == (b.varietyId ?? 0)) && ((a.name ?? "") === (b.name ?? ""))
    }

    return true

}


